import { render, staticRenderFns } from "./WizardProgressBar.vue?vue&type=template&id=653ebab8&scoped=true"
import script from "./WizardProgressBar.vue?vue&type=script&lang=js"
export * from "./WizardProgressBar.vue?vue&type=script&lang=js"
import style0 from "./WizardProgressBar.vue?vue&type=style&index=0&id=653ebab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ebab8",
  null
  
)

export default component.exports